import React from "react";
import Header from "@components/Header";
import Footer from "@components/Footer";
import Layout from "@components/Layout";

import Home from "../components/Home";

const home = () => {
  return (
    <Layout includeFooter recordLocation={false}>
      <Home />
    </Layout>
  );
};

export default home;
